import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const specials = css`
  display: grid;
  grid-template-columns: repeat(2, 19.25rem);
  grid-gap: 1rem;
  grid-auto-rows: 1fr;
  margin-left: 1rem;
  @media (max-width: ${dimensions.widescreen}) and (min-width: ${dimensions.tabletMax}) {
    grid-template-columns: 1fr;
    width: 19.25rem;
  }

  @media (max-width: ${dimensions.tabletMax}) {
    display: flex;
    flex-direction: column;
    margin: 1rem 1rem 1rem 0.5rem;
    padding-bottom: 1rem;
    li,
    li:first-of-type,
    li:last-of-type {
      border: none;
      padding: 0;
    }
  }
`;

export const special = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${theme.system.backgroundBase};
  border-radius: ${borders.radiusBase};
  color: ${theme.system.textBase};
  padding: 1rem;
  @media (max-width: ${dimensions.tabletMax}) {
    border: 1px solid ${theme.system.borderBase};
  }
`;

export const specialImageWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10rem;
  margin-bottom: 0.5rem;

  img {
    height: 4.375rem;
  }

  @media (max-width: ${dimensions.tabletMax}) {
    height: 9.125rem;
  }
`;

export const title = css`
  display: inline-flex;
  width: 100%;
  height: 100%;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`;
